'use strict';

angular.module('otpp-feature-toggles', []);
